import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from "@mui/material";
import { Link } from "react-router-dom";

const RankingTable = (props) => {
	const { title, field, color, data } = props;

	return (
		<Box>
			<TableContainer>
				<Table sx={{
					"& td, & th": {
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis", // opcional
					}
					}}>
					<TableHead>
						<TableRow>
							<TableCell><b>Ticker</b></TableCell>
							<TableCell align="center"><b>{title}</b></TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{data.map((row) => (
						<TableRow key={row.ticker}>
							<TableCell sx={{ py: 1, px: 0.5 }} flex={1}><Link to={'/company/'+ row.ticker}>{row.ticker}</Link></TableCell>
							<TableCell sx={{ py: 1, color: color, width: 100 }} align="center">
								{ props.format ? (
									props.format(row[field])
								) :( 
									row[field]
								)}
							</TableCell>
						</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
}

export default RankingTable;